<div
    class="agpr-entityBusinessCardExpanded"
    [class.agpr-entityBusinessCardExpanded--rhp]="isRHP"
    [ngClass]="businessCardClass"
>
    <div class="agpr-entityBusinessCardExpanded-thumbnail">
        <agpr-button
            [ngClass]="{'agpr-entityBusinessCardExpanded-thumbnail-image--nonClickable': !canOpenFullProfile}"
            [imageClass]="{
                'agpr-entityBusinessCardExpanded-thumbnail-image': true,
                'agpr-entityBusinessCardExpanded-thumbnail-image--scrolled': isScrolled
            }"
            [style]="buttonTypes.image"
            [imageUrl]="fullEntity?.avatarUrl | twitterAvatarSize:twitterAvatarSizes.original"
            [imageUrlDefault]="imageDefault[fullEntity?.entityType]"
            [tooltip]="canOpenFullProfile ? 'Discover.entityProfile.expand': ''"
            ariaLabel="Discover.entityProfile.expand"
            (click)="openFullProfile(fullEntity)"
            [hideImageAlt]="true"
        ></agpr-button>
        @if(!isRHP && contactEntity?.badges){
        <div
            class="agpr-entityBusinessCardExpanded-badges"
            [ngClass]="badgesClass"
        >
            @for(badge of (fullEntity?.entityType === entityTypes.CONTACT? contactEntity.badges : outletEntity.badges); track badge.tooltip) {
                <span
                    role="img"
                    class="agpr-entityBusinessCardExpanded-badge"
                    [ngClass]="badge?.iconClass"
                    [agprTooltip]="badge?.tooltip"
                ></span>
            }
        </div>
    }

    </div>
    @if(fullEntity?.entityType === entityTypes.OUTLET){
        <div
            class="agpr-entityBusinessCardExpanded-basicInfo"
            [ngClass]="basicInfoClass"
        >
            <div
                class="agpr-entityBusinessCardExpanded-name"
                [ngClass]="{
                    'agpr-entityBusinessCardExpanded-name--scrolled': isScrolled,
                    'agpr-entityBusinessCardExpanded-name--nonClickable': !canOpenFullProfile
                }"
                (click)="isRHP && openFullProfile(fullEntity)"
                role="heading"
                [attr.aria-level]="isRHP ? 4 : 1"
            >
                <span
                    #outletNameLabel
                    tabindex="0"
                >
                    {{ outletEntity.name }}
                </span>
            </div>
            @if(outletEntity?.mediaTypes.length > 0){
                <div
                    class="agpr-entityBusinessCardExpanded-outlet-jobTitle"
                    [ngClass]="outletTitleClass"
                >
                    <div
                        class="agpr-entityBusinessCardExpanded-items"
                        *ngFor="let mediaType of outletEntity.mediaTypes; let last = last"
                    >
                        {{ mediaType.displayString | localize }}{{ !last ? ', ' : '' }}
                    </div>

                    @if(outletEntity.coverageFocus) {
                        <div
                            class="agpr-entityBusinessCardExpanded-items"
                        >
                            {{ ' - ' }}{{ outletEntity.coverageFocus.displayString | localize }}
                        </div>
                    }
                </div>
            }
        </div>
    }
    @if(fullEntity?.entityType === entityTypes.CONTACT){
        <div
            class="agpr-entityBusinessCardExpanded-basicInfo"
            [ngClass]="basicInfoClass"
        >
            <div
                class="agpr-entityBusinessCardExpanded-name"
                [ngClass]="{
                    'agpr-entityBusinessCardExpanded-name--scrolled': isScrolled,
                    'agpr-entityBusinessCardExpanded-name--nonClickable': !canOpenFullProfile
                }"
                (click)="isRHP && openFullProfile(fullEntity)"
                role="heading"
                [attr.aria-level]="isRHP ? 4 : 1"
            >
                <span
                    #contactNameLabel
                    tabindex="0"
                >
                    {{ contactEntity.firstName }} {{ contactEntity.lastName }}
                </span>

            </div>
            @if (selectedEmployment?.jobTitle) {
                <div
                    class="agpr-entityBusinessCardExpanded-jobTitle"
                    [ngClass]="profileTitleClass"
                >
                    {{ selectedEmployment.jobTitle }}
                </div>
            }
            @if (!!selectedEmployment) {
                <div class="agpr-entityBusinessCardExpanded-outletContainer">
                    @if(!isScrolled && fullEntity?.entityType !== entityTypes?.OUTLET && selectedEmployment?.outlet){
                        <ng-container>
                            <img class="agpr-entityBusinessCardExpanded-outlet-thumbnail-imgOutlet"
                                [agprImageSrc]="selectedEmployment?.outlet.avatarUrl | twitterAvatarSize:twitterAvatarSizes.original"
                                [agprDefaultImage]="imageDefault.SMALL_OUTLET" alt="" />
                        </ng-container>
                    }
                    @if(contactEntity?.employmentModels?.length > 1){
                        <div
                            class="agpr-entityBusinessCardExpanded-outlet"
                            [ngClass]="{ 'agpr-entityBusinessCardExpanded-outlet--scrolled': isScrolled}"
                        >

                            <agpr-dropdown
                                [ngClass]="outletDropdownClass"
                                [id]="id + '_employmentDropdown'"
                                class="agpr-entityBusinessCardExpanded-outletDropdown"
                                panelStyleClass="agpr-entityBusinessCardExpanded-outletDropdown-panel"
                                [style]="dropdownTypesEnum.borderless"
                                [options]="outletDropdownOptions"
                                [ngModel]="selectedEmploymentDropdown"
                                (ngModelChange)="employmentSelectedFromDropdown($event.value)"
                                ariaLabel="Discover.targeting.actions.selectEmployedtOutlet"
                                [showTooltip]="true"
                            >
                            </agpr-dropdown>
                        </div>
                    }
                    @if(selectedEmployment?.outlet && contactEntity?.employmentModels?.length === 1){
                        <div
                            class="agpr-entityBusinessCardExpanded-outletName"
                            [ngClass]="outletNameClass"
                        >
                            @if(selectedEmployment?.outlet){
                                <agpr-button
                                    [style]="buttonTypes.link"
                                    class="agpr-entityBusinessCardExpanded-outletName-link"
                                    [ngClass]="{'agpr-entityBusinessCardExpanded-outletName-link--isRHP': isRHP}"
                                    [tooltip]="selectedEmployment?.outlet.name"
                                    (click)="targetingRhpContextsService.selectOutletContactTab(contactOutletTabTypes.outletProfile)"
                                >
                                    {{ selectedEmployment?.outlet.name }}
                                </agpr-button>
                            }
                        </div>
                    }
                </div>
            }
        </div>
    }

    @if (isScrolled) {
        <div
            class="agpr-entityBusinessCardExpanded-spacer"
        ></div>
    }
</div>
